import type React from "react"
import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "@/app/hooks"
import {
  fetchTags,
  selectTags,
  selectCurrentTags,
  setTags,
} from "@/features/posts/postsSlice" // Using absolute path
import "./PostTagFilter.css"

export const PostTagFilter: React.FC = () => {
  const dispatch = useAppDispatch()
  const tags = useAppSelector(selectTags)
  const currentTags = useAppSelector(selectCurrentTags)

  useEffect(() => {
    dispatch(fetchTags())
  }, [dispatch])

  const handleTagClick = (tagName: string) => {
    // Single selection logic based on UI (or toggle)
    // "전체" logic: if currentTags includes tagName, unselect?
    // For now, implementing single selection or "All" logic
    let newTags: string[]

    if (tagName === "ALL") {
      newTags = []
    } else {
      // Toggle logic
      if (currentTags.includes(tagName)) {
        newTags = currentTags.filter(t => t !== tagName)
      } else {
        // newTags = [...currentTags, tagName]; // Multi-select
        newTags = [tagName] // Single select behavior as per common UI patterns for categories
      }
    }
    dispatch(setTags(newTags))
  }

  const isAllActive = currentTags.length === 0

  return (
    <div className="post-tag-filter-container">
      <div className="post-tag-scroll-area">
        <button
          className={`post-tag-chip ${isAllActive ? "active" : ""}`}
          onClick={() => { handleTagClick("ALL"); }}
        >
          전체
        </button>
        {tags.map(tag => (
          <button
            key={tag.id}
            className={`post-tag-chip ${
              currentTags.includes(tag.name) ? "active" : ""
            }`}
            onClick={() => { handleTagClick(tag.name); }}
          >
            {tag.title}
          </button>
        ))}
      </div>
    </div>
  )
}
